export const CONSENT_STORAGE_KEY = "eva_cookie_consent";
export const CONSENT_POLICY_VERSION = "2026-09-09";
export const CONSENT_BANNER_VERSION = "1.0.0";
export const CONSENT_MAX_AGE_MONTHS = 6;

export const defaultConsentCategories = Object.freeze({
  necessary: true,
  audienceMeasurement: false,
  experienceAnalytics: false,
});

export const consentCopy = {
  it: {
    bannerTitle: "Scelte sui cookie",
    bannerText:
      "Usiamo tecnologie necessarie al funzionamento del sito. Solo con il tuo consenso, Google Analytics e PostHog misurano le visite e ci aiutano a migliorare il sito. Puoi rifiutare senza perdere l’accesso e cambiare scelta in qualsiasi momento.",
    policyLink: "Cookie Policy",
    reject: "Rifiuta non necessari",
    customise: "Personalizza",
    accept: "Accetta tutti",
    rejectClose: "Chiudi e continua solo con le tecnologie necessarie",
    manage: "Impostazioni cookie",
    preferencesTitle: "Preferenze sui cookie",
    preferencesIntro:
      "Scegli liberamente. Le categorie non necessarie sono disattivate per impostazione predefinita.",
    closePreferences: "Chiudi preferenze",
    necessaryTitle: "Necessari",
    necessaryDescription:
      "Memorizzano la lingua, proteggono i moduli e ricordano le tue scelte. Non misurano né profilano la navigazione.",
    alwaysActive: "Sempre attivi",
    audienceTitle: "Misurazione del pubblico",
    audienceDescription:
      "Google Analytics misura visite e pagine consultate. Google può ricevere dati tecnici sul dispositivo e sulla navigazione.",
    audienceLabel: "Consenti la misurazione del pubblico con Google Analytics",
    experienceTitle: "Analisi dell’esperienza",
    experienceDescription:
      "PostHog misura l’uso delle pagine. La registrazione delle sessioni e la raccolta automatica delle interazioni sono disattivate.",
    experienceLabel: "Consenti l’analisi dell’esperienza con PostHog",
    disabled: "Disattivato",
    enabled: "Attivato",
    rejectAll: "Rifiuta tutti",
    save: "Salva selezione",
  },
  en: {
    bannerTitle: "Cookie choices",
    bannerText:
      "We use technologies that are necessary for this website to work. Only with your consent will Google Analytics and PostHog measure visits and help us improve the website. You can reject them without losing access and change your choice at any time.",
    policyLink: "Cookie Policy",
    reject: "Reject non-essential",
    customise: "Customise",
    accept: "Accept all",
    rejectClose: "Close and continue with necessary technologies only",
    manage: "Cookie settings",
    preferencesTitle: "Cookie preferences",
    preferencesIntro:
      "Choose freely. Non-essential categories are switched off by default.",
    closePreferences: "Close preferences",
    necessaryTitle: "Necessary",
    necessaryDescription:
      "They remember the language and your choices and protect forms. They do not measure or profile your browsing.",
    alwaysActive: "Always active",
    audienceTitle: "Audience measurement",
    audienceDescription:
      "Google Analytics measures visits and pages viewed. Google may receive technical data about the device and browsing.",
    audienceLabel: "Allow audience measurement with Google Analytics",
    experienceTitle: "Experience analytics",
    experienceDescription:
      "PostHog measures page usage. Session recordings and automatic interaction capture are disabled.",
    experienceLabel: "Allow experience analytics with PostHog",
    disabled: "Off",
    enabled: "On",
    rejectAll: "Reject all",
    save: "Save selection",
  },
};

export const technologyRegistry = [
  {
    name: "eva_cookie_consent",
    provider: "Eva Tazzari",
    category: "necessary",
    storage: "localStorage",
    duration: { it: "6 mesi", en: "6 months" },
    purpose: {
      it: "Memorizza la scelta e la versione dell’informativa.",
      en: "Stores the choice and the policy version.",
    },
  },
  {
    name: "language",
    provider: "Eva Tazzari",
    category: "necessary",
    storage: "localStorage",
    duration: {
      it: "Fino alla cancellazione dal browser",
      en: "Until removed from the browser",
    },
    purpose: {
      it: "Ricorda la lingua scelta.",
      en: "Remembers the selected language.",
    },
  },
  {
    name: "splash_seen",
    provider: "Eva Tazzari",
    category: "necessary",
    storage: "sessionStorage",
    duration: { it: "Sessione del browser", en: "Browser session" },
    purpose: {
      it: "Evita di ripetere l’introduzione nella stessa sessione.",
      en: "Prevents the introduction from repeating in the same session.",
    },
  },
  {
    name: "Cloudflare Turnstile",
    provider: "Cloudflare, Inc.",
    category: "necessary",
    storage: { it: "Cookie e segnali tecnici del provider", en: "Provider cookies and technical signals" },
    duration: {
      it: "Secondo la configurazione e l’informativa Cloudflare",
      en: "According to Cloudflare’s configuration and policy",
    },
    purpose: {
      it: "Protegge i moduli da abusi e invii automatici.",
      en: "Protects forms against abuse and automated submissions.",
    },
  },
  {
    name: "_ga, _ga_<container-id>",
    provider: "Google Ireland Limited",
    category: "audienceMeasurement",
    storage: { it: "Cookie di prima parte", en: "First-party cookies" },
    duration: { it: "Fino a 6 mesi", en: "Up to 6 months" },
    purpose: {
      it: "Distingue in modo pseudonimo le visite e produce statistiche aggregate.",
      en: "Pseudonymously distinguishes visits and produces aggregate statistics.",
    },
  },
  {
    name: "ph_<project>_posthog",
    provider: "PostHog, Inc.",
    category: "experienceAnalytics",
    storage: { it: "Cookie e localStorage", en: "Cookie and localStorage" },
    duration: { it: "Fino a 6 mesi", en: "Up to 6 months" },
    purpose: {
      it: "Produce statistiche pseudonime sull’uso delle pagine.",
      en: "Produces pseudonymous statistics about page usage.",
    },
  },
];

export const categoryLabels = {
  necessary: { it: "Necessari", en: "Necessary" },
  audienceMeasurement: { it: "Misurazione del pubblico", en: "Audience measurement" },
  experienceAnalytics: { it: "Analisi dell’esperienza", en: "Experience analytics" },
};
